import { render, staticRenderFns } from "./UpdateEvent.vue?vue&type=template&id=2405f6e8&scoped=true"
import script from "./UpdateEvent.vue?vue&type=script&lang=js"
export * from "./UpdateEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2405f6e8",
  null
  
)

export default component.exports